export const CursoEntity = {
    id: null,
    codigo: '',
    titulo: '',
    descripcion: '',
    ponente: '',
    hora: '',
    fecha: '',
    fechafin: '',
    esCurso: false,
    resolucion: '',
    flyer: '',
    activo: false,
    datos: '',
    material: '',
    video: '',
    categoria: {
        id: null,
        titulo: '',
    },

    imagen: null,
};
        